/**
 * If Ghost/HTML only has .transform-digital with .left-content (no .transform-digital__cards),
 * build the two-column layout and insert the 2x2 card grid. Asset URLs come from #yes-td-asset.
 */
(function () {
  var payload = document.getElementById('yes-td-asset');
  if (!payload) return;
  var i360 = payload.getAttribute('data-i360') || '';
  var v2030 = payload.getAttribute('data-v2030') || '';
  var i6 = payload.getAttribute('data-i6') || '';
  var e2e = payload.getAttribute('data-e2e') || '';

  function cardsHtml() {
    return (
      '<div class="transform-digital__cards" role="list">' +
        '<article class="transform-digital__card" role="listitem">' +
          '<div class="transform-digital__card-icon" aria-hidden="true">' +
            '<img src="' + i360 + '" alt="" width="32" height="32" loading="lazy" decoding="async">' +
          '</div>' +
          '<h2 class="transform-digital__card-title">360°</h2>' +
          '<p class="transform-digital__card-text">VR Environment Coverage</p>' +
        '</article>' +
        '<article class="transform-digital__card transform-digital__card--accent" role="listitem">' +
          '<div class="transform-digital__card-icon" aria-hidden="true">' +
            '<img src="' + v2030 + '" alt="" width="32" height="32" loading="lazy" decoding="async">' +
          '</div>' +
          '<h2 class="transform-digital__card-title">V.2030</h2>' +
          '<p class="transform-digital__card-text">Aligned Solutions</p>' +
        '</article>' +
        '<article class="transform-digital__card" role="listitem">' +
          '<div class="transform-digital__card-icon" aria-hidden="true">' +
            '<img src="' + i6 + '" alt="" width="32" height="32" loading="lazy" decoding="async">' +
          '</div>' +
          '<h2 class="transform-digital__card-title">6+</h2>' +
          '<p class="transform-digital__card-text">Key Industries Served</p>' +
        '</article>' +
        '<article class="transform-digital__card" role="listitem">' +
          '<div class="transform-digital__card-icon" aria-hidden="true">' +
            '<img src="' + e2e + '" alt="" width="32" height="32" loading="lazy" decoding="async">' +
          '</div>' +
          '<h2 class="transform-digital__card-title">End-to-End</h2>' +
          '<p class="transform-digital__card-text">Concept to Deployment</p>' +
        '</article>' +
      '</div>'
    );
  }

  function ensureInner(container, left) {
    var existing = container.querySelector(':scope > .transform-digital__inner');
    if (existing) return existing;
    var inner = document.createElement('div');
    inner.className = 'transform-digital__inner';
    if (left) {
      inner.appendChild(left);
    }
    container.appendChild(inner);
    return inner;
  }

  function run() {
    var roots = document.querySelectorAll('section.transform-digital, div.transform-digital');
    if (!roots.length) return;
    [].forEach.call(roots, function (section) {
      if (!section.classList.contains('transform-digital')) return;
      if (section.querySelector('.transform-digital__cards')) return;

      var container = section.querySelector('.container');
      if (!container) return;

      var left =
        container.querySelector(':scope > .left-content') ||
        section.querySelector('.left-content');
      if (!left) return;

      var inner = container.querySelector(':scope > .transform-digital__inner');
      if (inner) {
        inner.insertAdjacentHTML('beforeend', cardsHtml());
        return;
      }

      ensureInner(container, left);
      inner = container.querySelector(':scope > .transform-digital__inner');
      if (inner) {
        inner.insertAdjacentHTML('beforeend', cardsHtml());
      }
    });
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
})();
